<template>
  <el-cascader
    v-model="modelValue"
    :placeholder="placeholder"
    :filterable="filterable"
    :props="selectProps"
  ></el-cascader>
</template>
<script>
import { cloneDeep } from "lodash-unified";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      default: ()=>[]
    },
    selectProps: {
      type: Object,
      default: () => {
        return {
          label: "title",
          value: "id",
        };
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    modelValue: {
      get() {
        return cloneDeep(this.value);
      },
      set(news) {
        this.$emit("input", news);
        return news;
      },
    },
  },
};
</script>
<style lang="less">
.virtualized-select {
  height: 270px;
  .el-select-dropdown__item {
    width: 250px;
  }
  &.no-virtualized-select {
    height: auto;
  }
}
</style>